(function (angular) {
	'use strict';

	angular
		.module('PinMeTo.notifications')
		.service(
			'pmtNotificationService',
			function ($http, $q, $timeout, $stateParams, auth, pmtSiteInfoService) {
				var self = this;
				self.notifications = [];
				self.dismissNotification = dismissNotification;
				self.dismissAllNotifications = dismissAllNotifications;
				self.getNotifications = getNotifications;
				self.subscribeToNotifications = subscribeToNotifications;

				self.knownNotificationIds = [];

				var getSiteName = function () {
					return $q.resolve($stateParams.site);
				};

				getSiteName().then(function () {
					pmtSiteInfoService.subscribeToNotifications(receiveNotifications);
				});

				function receiveNotifications(notifications) {
					var n = 0;

					notifications.forEach(function (notification) {
						var exists = self.knownNotificationIds.find(function (n) {
							return notification._id === n;
						});

						if (!exists) {
							self.knownNotificationIds.push(notification._id);
							$timeout(function () {
								self.notifications.push(notification);
								message('Notifications', self.notifications);
							}, 200 * n);
							n++;
						}
					});
				}

				function getNotifications() {
					return getSiteName().then(function (siteName) {
						var defer = $q.defer();
						$http
							.get('api/' + siteName + '/notifications')
							.then(function (response) {
								if (response.data.success && response.data.data) {
									defer.resolve(response.data.data);
								} else {
									defer.reject('Something went wrong.');
								}
							})
							.catch(function (error) {
								defer.reject(error);
							});

						return defer.promise;
					});
				}

				function dismissNotification(notification) {
					return getSiteName().then(function (siteName) {
						var defer = $q.defer();
						$http
							.post('api/' + siteName + '/notifications/dismiss/', { _id: notification._id })
							.then(function (response) {
								if (response.data.success && response.data.data) {
									self.notifications = self.notifications.filter(function (n) {
										return notification !== n;
									});
									message('Notifications', self.notifications);
									defer.resolve();
								} else {
									console.log('Could not dismiss', notification);
									defer.reject(response.data.error);
								}
							})
							.catch(function (error) {
								defer.reject(error);
							});

						return defer.promise;
					});
				}

				function dismissAllNotifications() {
					return getSiteName().then(function (siteName) {
						var defer = $q.defer();

						$http
							.post('api/' + siteName + '/notifications/dismissAll')
							.then(function (response) {
								if (response.data.success) {
									self.notifications = [];
									message('Notifications', self.notifications);
									defer.resolve();
								} else {
									defer.reject('Something went wrong.');
								}
							})
							.catch(function (error) {
								defer.reject(error);
							});

						return defer.promise;
					});
				}

				var subscribers = {};
				function subscribe(key, callback) {
					if (!subscribers[key]) {
						subscribers[key] = [];
					}
					subscribers[key].push(callback);
				}
				function message(key, message) {
					subscribers[key].forEach(function (subscriber) {
						subscriber(message);
					});
				}

				function subscribeToNotifications(callback) {
					subscribe('Notifications', callback);
					message('Notifications', self.notifications);
				}
			}
		);
})(window.angular);
